import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "nav-label" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "nav-label" }
const _hoisted_5 = { class: "nav-label" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();

const isHome      = computed(() => route.name === "home");
const isAquariums = computed(() => route.name === "aquariums");
const isPlants    = computed(() => route.name === "plants");
const isProfile   = computed(() => route.name === "profile");

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, { to: { name: 'home' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['nav-item', { active: isHome.value }])
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isHome.value ? 'mdi-home' : 'mdi-home-outline'), 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('nav.home')), 1)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'aquariums' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['nav-item', { active: isAquariums.value }])
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isAquariums.value ? 'mdi-fishbowl' : 'mdi-fishbowl-outline'), 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('nav.aquariums')), 1)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'plants' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['nav-item', { active: isPlants.value }])
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isPlants.value ? 'mdi-sprout' : 'mdi-sprout-outline'), 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('nav.plants')), 1)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'profile' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['nav-item', { active: isProfile.value }])
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isProfile.value ? 'mdi-account' : 'mdi-account-outline'), 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('nav.profile')), 1)
          ], 2)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})